import angular from 'angular'

import '../../core/main/filter/country_help_url/filter'
import '../../main/factory/authentication'
import '../../main/directive/permissions/directive'
import '../../main/factory/merchant'
import './style.scss'

document.write(require('./view.html').default)

angular.module('merchant.application.module.header',
  ['jm.i18next', 'merchant.application.module.languageSelector']).controller('merchant.application.module.header.controller', [
  '$rootScope', '$route', '$scope', '$controller',
  'merchant.application.main.factory.authentication',
  'merchant.application.main.factory.merchant',
  'core.application.main.controller.environment',
  'merchant.application.main.factory.settlement',
  '$timeout',
  '$resource',
  'core.application.main.factory.feature',
  function ($rootScope, $route, $scope, $controller, Authentication, Merchant, Environment, Settlement, $timeout, $resource, Feature) {
    Feature.retrieveFeatureFlagPromise('merchant-portal-language-selector-enabled', false)
      .then(function (value) {
        $scope.langSelectorEnabled = value
        $scope.$apply()
      })

    $controller('merchant.application.module.controller', { $scope: $scope })

    $scope.currentMerchant = Authentication.currentMerchant()
    $scope.availableMerchants = Authentication.availableMerchants()
    $scope.logoSrc = 'image/logo.svg'
    $scope.reconciliationTabLink = 'reconciliations'
    $scope.model.showLanguageDialog = false
    $scope.isLinkActive = function (pageName) {
      // pageName: the page name to check if it's active
      //     string if one page name
      //     array of strings if more than one page name
      return pageName.indexOf($scope.activePageName) !== -1
    }

    $scope.isLoggedIn = function () {
      return Authentication.loggedIn()
    }

    $scope.displayName = function () {
      return Authentication.displayName()
    }

    $scope.tradingName = function () {
      return Authentication.tradingName()
    }

    $scope.isSingleMerchant = function () {
      return Authentication.hasManyMerchants() === false
    }

    $scope.isMultiMerchant = function () {
      return Authentication.hasManyMerchants()
    }

    $scope.switchMerchant = function (selectedMerchant) {
      Authentication.switchMerchant(selectedMerchant)
      $scope.setReconciliationTab(selectedMerchant.id)
      // After switching to a new merchant we need to reload all data
      // in the context of controller, not whole app.
      $route.reload()
    }

    $scope.populateInStoreUrl = function () {
      if (
        Authentication.hasAnyPermissions(['ACTIVATE_DEVICE', 'CREATE_ORDER']) &&
                Authentication.hasAnyChannel(['IN_STORE'])
      ) {
        return 'in-store/barcode'
      }

      if (
        Authentication.hasAnyPermissions(['VIEW_POS_CARD', 'EDIT_POS_CARD']) &&
                Authentication.hasAnyChannel(['IN_STORE_CARD', 'IN_STORE_CARD_ONLINE'])
      ) {
        return 'in-store/card/acquirer-details'
      }
    }

    // If online-card is enabled, make it the default reconciliation tab
    $scope.setReconciliationTab = function (merchantId) {
      Settlement.readOnlineCardSettlementEnabled({ merchantId: merchantId || Authentication.merchantId() }, function (response) {
        $scope.reconciliationTabLink = response.enabled == 'true' ? 'online-card-reconciliations' : 'reconciliations'
      }, function () {
        $scope.reconciliationTabLink = 'reconciliations'
      })
    }
    $scope.showLanguageModal = function () {
      if ($scope.model.showLanguageDialog) {
        $scope.model.showLanguageDialog = false
      } else {
        $scope.model.showLanguageDialog = true
      }
    }
    // load admin trial user list -- temporary
    $scope.model.showAdminMenu = false
    const endpoint = Environment.MERCHANT_PORTAL_API_BASE_URL + '/portal/merchants/:merchantId/admin-shop-feed-trial'

    const resourceCheckAdminTrial = $resource(endpoint)

    if ($scope.currentMerchant && $scope.currentMerchant.id) {
      resourceCheckAdminTrial.get({ merchantId: $scope.currentMerchant.id }, (result) => {
        if (result && result.enabled) {
          $scope.model.showAdminMenu = true
          $timeout(() => $scope.$apply())
        }
      })
    }

    $rootScope.$on('merchantChanged', function () {
      $scope.currentMerchant = Authentication.currentMerchant()
      $scope.setReconciliationTab($scope.currentMerchant.id)
    })

    $rootScope.$on('availableMerchantsChanged', function () {
      $scope.availableMerchants = Authentication.availableMerchants()
    })
  }
])
